import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { ArrowIcon } from 'src/assets/new-icon/ArrowIcon';
import { TrashIcon } from 'src/assets/icons/TrashIcon';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { EditIcon } from 'src/assets/new-icon/EditIcon';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { mediaQuery } from 'src/assets/media-query-config';
import { SaveIcon } from 'src/assets/new-icon/SaveIcon';
import { ChevronIcon } from 'src/assets/new-icon/ChevronIcon';
import { ChevronIconWrapper } from 'src/components/CmsCasinoManagement/GameRow/GameRow.style';
import { CopyIcon } from 'src/assets/new-icon/CopyIcon';

export const CategoryHeaderWrapper = styled('div', { label: 'CategoryHeaderWrapper' })`
    background-color: ${casinoColors.bgColorCategoryHeader};
    display: flex;
    justify-content: space-between;
    padding: 16px 55px 16px 16px;
    position: relative;
    width: 100%;
`;

export const LeftSide = styled('div', { label: 'LeftSide' })`
    display: flex;
    flex: 0 0 125px;
    @media ${mediaQuery.largeDesktop} {
        flex: 0 0 150px;
    }
`;

interface EditNamePropsType {
    isNameEdited: boolean;
}

export const EditNameWrapper = styled('div', { label: 'EditNameWrapper' })<EditNamePropsType>`
    align-items: center;
    cursor: ${({ isNameEdited }): string => isNameEdited ? 'pointer' : 'default'};
    display: flex;
`;

export const InputWrapper = styled(OldInput, { label: 'InputWrapper' })`
    background: inherit;
    border: none;
    color: ${casinoColors.txtColorCategoryHeader};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    outline: none;
    padding-top: 0;
    padding-bottom: 0;
`;

export const HeaderLabel = styled(InputLabel, { label: 'HeaderLabel' })`
    color: ${casinoColors.txtColorCategoryHeader};
    font-weight: ${fontWeight.bold};
    margin: 0;
`;

export const EditIconWrapper = styled(EditIcon, { label: 'EditIconWrapper' })`
    cursor: pointer;
    margin-right: 6px;
`;

export const SaveIconWrapper = styled(SaveIcon, { label: 'SaveIconWrapper' })`
    cursor: pointer;
    margin: 0 6px;
`;

interface PropsType {
    isDisabled: boolean;
}

export const CategoryName = styled('div', { label: 'CategoryName' })<PropsType>`
    color: ${casinoColors.txtColorCategoryHeader};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    opacity: ${({ isDisabled }): string => isDisabled ? '.6' : '1'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const RightSide = styled('div', { label: 'RightSide' })`
    align-items: center;
    display: flex;
    flex: 1 0 260px;
    justify-content: flex-end;
    position: relative;
`;

export const ArrowsWrapper = styled('div', { label: 'ArrowsWrapper' })`
    display: flex;
`;

export const Arrow = styled(ArrowIcon, { label: 'Arrow' })<PropsType>`
    cursor: pointer;
    margin-right: 4px;
    opacity: ${({ isDisabled }): string => isDisabled ? '.6' : '1'};
`;

export const CheckboxLabel = styled('span', { label: 'CheckboxLabel' })<PropsType>`
    color: ${casinoColors.txtColorCategoryHeader};
    font-size: ${fontSize.xRegular};
    margin: 0 8px 0 18px;
    opacity: ${({ isDisabled }): string => isDisabled ? '.6' : '1'};
`;

export const IconWrapper = styled('span', { label: 'IconWrapper' })`
    display: flex;
    align-items: center;
    margin-left: 20px;
`;

export const SettingsDropdownWrapper = styled('div', { label: 'SettingsDropdownWrapper' })`
    display: flex;
    flex: 0 0 160px;
    margin: 0;
    max-width: 160px;
    position: relative;
`;

interface DropdownArrowPropsType {
    isOpen: boolean;
}

export const SettingsDropdownArrow = styled('div', { label: 'SettingsDropdownArrow' })<DropdownArrowPropsType>`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%) ${({ isOpen }): string => isOpen ? 'scaleY(-1)' : 'scaleY(1)'};
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid ${casinoColors.txtColorCategoryHeader};
    pointer-events: none;
    z-index: 2;
    transition: transform 0.2s ease;
`;

export const SettingsDropdownValue = styled('span', { label: 'SettingsDropdownValue' })`
    color: ${casinoColors.white};
    font-size: ${fontSize.small};
    line-height: 1.2;
    margin: 0;
    padding: 0 3px 0 0;
`;

interface TrashIconPropsType {
    isNoCheckbox: boolean;
}

export const TrashIconWrapper = styled(TrashIcon, { label: 'TrashIconWrapper' })<TrashIconPropsType>`
    cursor: pointer;
    fill: ${casinoColors.txtColorCategoryHeader};
    margin: 0 8px 0 16px;
    width: 11px;
`;

interface ChevronIconWrapperPropsType {
    isDisabled: boolean;
    onClick: () => void;
}

export const ChevronWrapper = styled(ChevronIconWrapper, { label: 'ChevronWrapper' })`
    right: 4px;
    top: 0;
    bottom: 0;
`;

export const Chevron = styled(ChevronIcon, { label: 'Chevron' })<ChevronIconWrapperPropsType>`
    fill: ${casinoColors.iconColorCategory};
    opacity: ${({ isDisabled }): string => isDisabled ? '.6' : '1'};
`;

export const CopyIconWrapper = styled(CopyIcon, { label: 'CopyIconWrapper' })`
    cursor: pointer;
    fill: ${casinoColors.txtColorCategoryHeader};
    width: 16px;
    margin: 0 8px;
`;
